import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { DevInfo } from '../../typings/dev';

import './DevInfoControl.css';

export interface DevInfoProps {
    cls?: string;
    devInfo: DevInfo;
}

export interface DevInfoState {
    java: {
        revision: string;
        version: string;
    };
}

export class DevInfoControl extends React.Component<DevInfoProps, DevInfoState> {
    constructor(props: DevInfoProps) {
        super(props);
        this.state = {
            java: {
                revision: 'loading',
                version: 'loading'
            }
        };

        this.getJavaInfo().then(response => {
            this.setState({
                java: response
            });
        });
    }
    render() {
        const {
            cls,
            devInfo: { svn }
        } = this.props;
        const { java } = this.state;
        const commit = COMMITHASH.slice(0, 7);

        return (
            <div className={classNames(Bem.cls('dev-info-control'), cls)}>
                <div>svn: {`${svn.branch} (r${svn.revision}) `}</div>
                <div>java: {`${java.version} (r${java.revision}) `}</div>
                <div>dna: {`${BRANCH} (${commit}) release: ${VERSION} `}</div>
            </div>
        );
    }

    async getJavaInfo() {
        try {
            const response = await fetch(`/web-api/admin?action=version`, {
                method: 'GET'
            });

            const result = await response.json();

            return result;
        } catch (error) {
            return {
                revision: 'error-on-load',
                version: 'error-on-load'
            };
        }
    }
}
